/**
 * Normalize the index of a given list by moving the given index into the list boundaries.
 * A circular array is one where we consider first element as following the last element,
 * and last element as preceding the first element.
 */
export function getNormalizedIndex(list, index) {
    return ((index % list.length) + list.length) % list.length;
}
/**
 * Get an element from an array by providing a circular index.
 * A circular array is one where we consider first element as following the last element,
 * and last element as preceding the first element.
 */
export function getByCircularIndex(list, index) {
    const normalizedIndex = getNormalizedIndex(list, index);
    return list[normalizedIndex];
}
export function isValidIndex(list, index) {
    return index >= 0 && index < list.length;
}
//# sourceMappingURL=ArrayHelpers.js.map